import { useSession } from '@adiox/ui';

/** Shown for the whole of an investor session, so nobody wonders why trading is switched off. */
export function ReadOnlyBanner() {
  const readOnly = useSession().user?.readOnly === true;
  if (!readOnly) return null;
  return (
    <p
      role="status"
      data-testid="read-only-banner"
      className="pointer-events-none fixed bottom-2 left-1/2 z-50 -translate-x-1/2 rounded-full border border-warn/40 bg-panel px-4 py-1 text-xs font-semibold text-warn shadow-lg"
    >
      Read-only view (investor password): trading is switched off.
    </p>
  );
}
